import { apiClient } from '../client';

export interface Feedback {
  feedback: string;
}

export class FeedbackService {
  private baseUrl = '/feedback';

  async createFeedback(feedback: Feedback): Promise<any> {
    const url = `${this.baseUrl}`;
    const response = await apiClient.post(url, feedback);
    return response.data;
  }
}

export const feedbackService = new FeedbackService();
